export { default as SurveyTitle } from './SurveyTitleV2';
export type { Props as SurveyTitleProps } from './SurveyTitleV2';
